import React, { useEffect } from "react";

// ──────────────────────────────────────────────────────────────────────────
// Google AdSense manual ad slot.
//
// The site uses Auto ads (the loader script in public/index.html is enough
// for Google to place ads automatically) so this renders nothing until a
// manual placement is needed.
//
// To use a manual slot instead of/alongside Auto ads:
//   1. Set ADS_ENABLED to true.
//   2. Create an ad unit in the AdSense dashboard and pass its slot ID,
//      e.g. <AdSlot slot="1234567890" /> (a missing slot ID serves nothing).
// ──────────────────────────────────────────────────────────────────────────
export const ADS_ENABLED = false;
const AD_CLIENT = "ca-pub-3278333315427275";

function AdSlot({ slot = "", format = "auto" }) {
  useEffect(() => {
    if (!ADS_ENABLED) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // AdSense script blocked or not loaded yet — fail silently.
    }
  }, []);

  if (!ADS_ENABLED) {
    return null;
  }

  return (
    <ins
      className="adsbygoogle ad-slot"
      style={{ display: "block" }}
      data-ad-client={AD_CLIENT}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    />
  );
}

export default AdSlot;
